import { Theme } from "./theme"

export const darkTheme: Theme = {
  name: "dark",
  colors: {
    bodyBg: "black",
    bg: "#333332",
    fg20: "rgba(0, 0, 0, 0.2)",
    fc: "white",
    iconBg: "#333332",
    nftDetailFrame: "black",
    iconButtonFont: "white",
    btnBg: "#333332",
    bigCavets: "#333332",
  },
}
